import { FilterChip, FiltersRow } from './styles';

export type QuickFilterKey =
  | 'overdue'
  | 'near_deadline'
  | 'no_inspector'
  | 'scheduled_today'
  | 'rejected_by_bank'
  | 'in_offer'
  | 'manual_required';

interface QuickFilterOption {
  key: QuickFilterKey;
  label: string;
}

// Sentence case (guide 9.6).
const OPTIONS: QuickFilterOption[] = [
  { key: 'overdue', label: 'Atrasadas' },
  { key: 'near_deadline', label: 'Próximas do prazo' },
  { key: 'scheduled_today', label: 'Agendadas hoje' },
  { key: 'no_inspector', label: 'Sem vistoriador' },
  { key: 'rejected_by_bank', label: 'Rejeitadas pelo banco' },
  // queue distribution (REAL-3271)
  { key: 'in_offer', label: 'Em oferta' },
  { key: 'manual_required', label: 'Atribuição manual' },
];

interface QuickFiltersProps {
  active: QuickFilterKey | null;
  onChange: (key: QuickFilterKey | null) => void;
  counters?: Partial<Record<QuickFilterKey, number>>;
}

export function QuickFilters({
  active,
  onChange,
  counters,
}: QuickFiltersProps): JSX.Element {
  return (
    <FiltersRow>
      {OPTIONS.map((option) => {
        const isActive = active === option.key;
        const count = counters?.[option.key];
        const label =
          count !== undefined ? `${option.label} · ${count}` : option.label;
        return (
          <FilterChip
            key={option.key}
            label={label}
            color={isActive ? 'primary' : 'default'}
            variant={isActive ? 'filled' : 'outlined'}
            onClick={() => onChange(isActive ? null : option.key)}
          />
        );
      })}
    </FiltersRow>
  );
}
